// removed by extract-text-webpack-plugin
module.exports = {"adBox":"style__adBox__1_AM4","real":"style__real__2IpyL","metricalAd":"style__metricalAd__XGPGW","text":"style__text__1BXFG","image":"style__image__2TtyG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/adBox/style.scss
// module id = 729
// module chunks = 0